import type { Prontuario } from "@/api/db/medico";
import { MedicoLabels } from "@/lib/labels/medico";
import { cn } from "@/lib/utils";

export function Relance({ items }: { items: Prontuario["relance"] }) {
	return (
		<div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
			{items.map((item) => (
				<div
					key={item.item_key}
					className={cn(
						"rounded-md border px-3 py-2",
						MedicoLabels.itemStateStyle[item.state].surface,
					)}
				>
					<div className="flex items-center justify-between gap-2">
						<span className="text-xs font-medium text-foreground">
							{MedicoLabels.relance[item.item_key] ?? item.item_key}
						</span>

						<span
							className={cn("text-xs font-medium", MedicoLabels.itemStateStyle[item.state].text)}
						>
							{MedicoLabels.itemState[item.state]}
						</span>
					</div>

					{item.value !== null && (
						<p className="mt-1 text-xs text-muted-foreground">{item.value}</p>
					)}
				</div>
			))}
		</div>
	);
}
